// The work page's sections, in page order. One store instead of window globals:
// the page registers its sections; the scroll controller, the section indicator
// and the page transition read them.

type Listener = () => void

let sections: HTMLElement[] = []
const listeners = new Set<Listener>()

export const Sections = {
    set(list: HTMLElement[]) {
        sections = list
        Sections.leaving = false
        listeners.forEach((l) => l())
    },
    clear(list: HTMLElement[]) {
        if (sections === list) {
            sections = []
            listeners.forEach((l) => l())
        }
    },
    get: () => sections,
    /** the category on screen in a feed of several ("<feed index>:<page id>"):
     *  the section indicator shows its cases only */
    current: "",
    setCurrent(c: string) {
        if (c === Sections.current) return
        Sections.current = c
        listeners.forEach((l) => l())
    },
    /** set by the scroll controller: animated scroll to a section */
    goTo: null as null | ((el: HTMLElement) => boolean),
    /** set by the scroll controller: the page is being left */
    leave: null as null | (() => void),
    /** true from the moment the page starts being left until the next one registers */
    leaving: false,
    subscribe(l: Listener) {
        listeners.add(l)
        return () => listeners.delete(l)
    },
    /** the section mostly on screen (more than 30% of the viewport) */
    onScreen(): HTMLElement | null {
        let el: HTMLElement | null = null,
            best = 0
        for (const s of sections) {
            if (!s.isConnected) continue
            const r = s.getBoundingClientRect()
            const v = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0)) / Math.max(1, innerHeight)
            if (v > best) ((best = v), (el = s))
        }
        return el && best > 0.3 ? el : null
    },
}

/** The covering layer the page transition leaves on screen for the next page. */
export const Handoff = {
    layer: null as null | { layer?: HTMLElement; remove: () => void },
    at: 0,
    /** take it (once); null if there is none or it's stale */
    take(maxAge = 8000) {
        const h = Handoff.layer
        Handoff.layer = null
        return h && Date.now() - Handoff.at < maxAge ? h : null
    },
    lift(h: { layer?: HTMLElement; remove: () => void } | null, ms = 420, ease = "cubic-bezier(.4,0,.2,1)") {
        if (!h) return
        if (!h.layer) return h.remove()
        h.layer.style.transition = `opacity ${ms}ms ${ease}`
        h.layer.style.opacity = "0"
        window.setTimeout(() => h.remove(), ms + 60)
    },
}

/** The next page lands on its first section (set by the transition, read once). */
export const Arrival = {
    requested: 0,

}
